export const LOGIN = "LOGIN";
export const SIGNUP = "SIGNUP";
export const YEAR_SELECTION = "YEAR_SELECTION";
export const GUEST_LOGIN = "GUEST_LOGIN";
export const PRE_ENROLL_INFO = "PRE_ENROLL_INFO";
export const SET_SPINNER = "SET_SPINNER";
export const PLAN_SELECTION_CONTINUE = "PLAN_SELECTION_CONTINUE";
export const GET_CLINICAL_NAME = "GET_CLINICAL_NAME";
export const SUBMIT_FORM = "SUBMIT_FORM";
export const DOWNLOAD_PDF = "DOWNLOAD_PDF";
export const SAVE_LOGOUT = "SAVE_LOGOUT";
export const FORGOT_LOGIN_DETAIL = "FORGOT_LOGIN_DETAIL";
export const RESET_LOGIN = "RESET_LOGIN";
export const REMOVEPLAN = "REMOVEPLAN";
export const SAVE_LANGUAGE = "SAVE_LANGUAGE";
export const PDF_UPLOAD = "PDF_UPLOAD";
export const SET_LOGIN_DATA = "SET_LOGIN_DATA";
export const TOKEN_TO_REDUX = "TOKEN_TO_REDUX";
export const RESET_STORE="RESET_STORE";
//===>
export const SET_FORM_DATA = "SET_FORM_DATA";
export const SET_ZIP = "SET_ZIP";
export const SET_LOGIN_STATE_PARAMS="SET_LOGIN_STATE_PARAMS";
export const SET_USER_MANAGEMENT_STATE_PARAMS="SET_USER_MANAGEMENT_STATE_PARAMS";
export const SET_CAMPAIGN_PROSPECT_STATE_PARAMS="SET_CAMPAIGN_PROSPECT_STATE_PARAMS";
export const SET_BULK_STATE_PARAMS="SET_BULK_STATE_PARAMS";
export const AGENT_LOGIN = "AGENT_LOGIN";
export const GET_PLAN_SUMMARY = "GET_PLAN_SUMMARY";
export const GET_PLAN_SUMMARY_BY_ZIP = "GET_PLAN_SUMMARY_BY_ZIP";
export const COMPARE_PLAN = "COMPARE_PLAN";
export const GET_PLAN_DETAILS = "GET_PLAN_DETAILS";
export const EMAIL_PLAN = "EMAIL_PLAN";
export const CATEGORY_DASHBOARD = "CATEGORY_DASHBOARD";
export const STATUS_DASHBOARD = "STATUS_DASHBOARD";
export const LOGOUT = "LOGOUT";
export const SUCCESSFUL_SIGNUP = "SUCCESSFUL_SIGNUP";
export const SET_ELIGIBILITY = "SET_ELIGIBILITY";
export const SEARCH_APPLICATION = "SEARCH_APPLICATION";
export const SET_ENROLLMENT_REDIRECT = "SET_ENROLLMENT_REDIRECT";
export const GET_PCPS = "GET_PCPS";
export const GET_ZIPCODES = "GET_ZIPCODES";
export const GET_MAILZIPCODES="GET_MAILZIPCODES";
export const SET_EMAil = "SET_EMAil";
export const SOA_DETAILS = "SOA_DETAILS";
export const SOA_PRODUCT_IDS="SOA_PRODUCT_IDS";
export const AGENTEMAILID = "AGENTEMAILID";
export const DEEPLINK = "DEEPLINK";
export const UPLOAD_FILES = "UPLOAD_FILES";
export const DELETE_FILE = "DELETE_FILE";
export const REMOVETOKEN="REMOVETOKEN";
export const SETPENDAPPLFLAG="SETPENDAPPLFLAG";
export const GET_CMP_NAMES="GET_CMP_NAMES";
export const CAMPAIGN_LIST="CAMPAIGN_LIST";
export const SET_PROSPECT_STATE="SET_PROSPECT_STATE";
export const SET_CAMPAIGN_STATE="SET_CAMPAIGN_STATE";
export const SAVE_SOA_DATA="SAVE_SOA_DATA";
export const GET_AGENT_LIST="GET_AGENT_LIST";
export const GET_LTC_LIST="GET_LTC_LIST";
export const SEARCH_PROSPECT="SEARCH_PROSPECT";
export const GET_CITY_LIST="GET_CITY_LIST";
export const SAVE_ENROLL_FORM="SAVE_ENROLL_FORM";
export const SAVE_CAMPAIGN_OWNER_FORM="SAVE_CAMPAIGN_OWNER_FORM";
export const SAVE_PROSPECT="SAVE_PROSPECT";
export const GET_CALLS_DATA="GET_CALLS_DATA";
export const GET_COMMENTS_DATA="GET_COMMENTS_DATA";
export const SET_CALLER_ID="SET_CALLER_ID";
export const ADD_NEW_COMMENT="ADD_NEW_COMMENT";
export const SET_LEAD_ID="SET_LEAD_ID";
export const SAVE_CALLS="SAVE_CALLS";
export const LOAD_DEMOGRAPHICS="LOAD_DEMOGRAPHICS";
export const LOAD_SOA="LOAD_SOA";
export const LOAD_PROSPECT_ROW="LOAD_PROSPECT_ROW";
export const GET_AGENCYID="GET_AGENCYID";
export const GET_AGENT_IN_FORM="GET_AGENT_IN_FORM";
export const GET_STATES="GET_STATES";
export const GET_CALLS_DATA_ROWSELECT="GET_CALLS_DATA_ROWSELECT";
export const KEY_PERFORMANCE_BY_AGENT="KEY_PERFORMANCE_BY_AGENT";
export const KEY_PERFORMANCE_BY_AGENT_STATE="KEY_PERFORMANCE_BY_AGENT_STATE";
export const  KEY_PERFORMANCE_BY_CAMPAIGN="KEY_PERFORMANCE_BY_CAMPAIGN";
export const KEY_PERFORMANCE_BY_CAMPAIGN_STATE="KEY_PERFORMANCE_BY_CAMPAIGN_STATE";
export const PCP_MAP_SEARCH = "PCP_MAP_SEARCH";
export const SET_PCP_DATA = "SET_PCP_DATA";
export const PCP_SEARCH_AND_SET = "PCP_SEARCH_AND_SET";
export const DIGITAL_SIGN="DIGITAL_SIGN";
export const EXPORT_PERFORMANCE_BY_AGENT="EXPORT_PERFORMANCE_BY_AGENT";
export const EXPORT_PERFORMANCE_BY_CAMPAIGN="EXPORT_PERFORMANCE_BY_CAMPAIGN";
export const GET_CAMPAIGN_NAMES="GET_CAMPAIGN_NAMES";
export const GET_CAMPAIGN_OWNER_NAMES="GET_CAMPAIGN_OWNER_NAMES";
export const CLEAR_PROSPECT_ROW_DATA="CLEAR_PROSPECT_ROW_DATA";
export const FORGET_EMAIL="FORGET_EMAIL";
export const NEW_VALUES_FOR_LOGIN="NEW_VALUES_FOR_LOGIN";
export const PIE_CHART_FILTER="PIE_CHART_FILTER";
export const PENDING_APP_LIST="PENDING_APP_LIST";
export const MEMBERSHIP_AGENT_lIST="MEMBERSHIP_AGENT_lIST";
export const CLEAR_PROSPECT_DATA="CLEAR_PROSPECT_DATA";
export const CLEAR_SOA_DATA="CLEAR_SOA_DATA";
export const GET_CUSTOMER_SUBDOMAIN="GET_CUSTOMER_SUBDOMAIN";
export const CAPTCHA="CAPTCHA";
export const GET_AUTH_RELATIONS="GET_AUTH_RELATIONS";
export const SET_PAGE_NAME="SET_PAGE_NAME";
export const DOWNLOAD_FORMS_PDF="DOWNLOAD_FORMS_PDF";
export const DOWNLOAD_SOA_PDF="DOWNLOAD_SOA_PDF"
export const SET_CATEGORY_NAME="SET_CATEGORY_NAME";
export const ASSIGN_PROSPECT="ASSIGN_PROSPECT";
export const SET_EVENTDATA="SET_EVENTDATA";
export const LOAD_EVENTS="LOAD_EVENTS";
export const SET_CALENDER_STATE="SET_CALENDER_STATE";
export const SET_LOGIN_VALUES="SET_LOGIN_VALUES";
export const PROSPECT_FILE_UPLOAD="PROSPECT_FILE_UPLOAD";
export const CAMPAIGN_FILE_UPLOAD="CAMPAIGN_FILE_UPLOAD";
export const GET_PROSPECT_FILES_DATA="GET_PROSPECT_FILES_DATA;"
export const GET_CAMPAIGN_FILES_DATA="GET_CAMPAIGN_FILES_DATA";
export const LOAD_CAMPAIGN_FILEDATA="LOAD_CAMPAIGN_FILEDATA";
export const LOAD_PROSPECT_FILEDATA="LOAD_PROSPECT_FILEDATA";
export const UPDATE_PROSPECT_RECORDS="UPDATE_PROSPECT_RECORDS";
export const UPDATE_CAMPAIGN_RECORDS="UPDATE_CAMPAIGN_RECORDS";
export const GET_SEP_REASONS="GET_SEP_REASONS";
export const RAPID_DISENROLLMENT_BYMONTH="RAPID_DISENROLLMENT_BYMONTH";
export const MBI_DETAILS="MBI_DETAILS";
export const VERDA_CARE_ENROLL_PDF="VERDA_CARE_ENROLL_PDF";
export const KEYCLOAK_TOKEN="KEYCLOAK_TOKEN";
export const KEYCLOAK_LOGOUT="KEYCLOAK_LOGOUT";
export const FETCH_KEYCLOAK_USERID="FETCH_KEYCLOAK_USERID"
export const FETCH_APPOINTMENTS="FETCH_APPOINTMENTS";
export const LOADPROSPECTONAGENT="LOADPROSPECTONAGENT";
export const SET_CALENDER_PARAMETER="SET_CALENDER_PARAMETER";
export const GET_USER_MANAGEMENT_DATA="GET_USER_MANAGEMENT_DATA";
export const  GET_USER_ROLE_CHANGE=" GET_USER_ROLE_CHANGE";
// export const  GET_USER_ROLE_CHANGE1=" GET_USER_ROLE_CHANGE1";
export const GET_FILE_ATTACHMENT_TYPES="GET_FILE_ATTACHMENT_TYPES";